import React from "react";
import { createGlobalStyle } from "styled-components";

import { CssBaseline } from "@material-ui/core";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme && props.theme.body.background};
  }
`;

function LandingLayout(props) {
    
  return (
    <React.Fragment>
      <CssBaseline />
      <GlobalStyle />
      {props.children}
    </React.Fragment>
  );
}

export default LandingLayout;
